import { Context, useContext, useEffect, useRef } from 'react';

import { isInExoSkeleton, report, REPORT_TYPES } from '@adsk/exo-skeleton-api';

type UseProviderOnlyOnceParams<T> = {
  context: Context<T>;
  contextName: string;
};

export const useProviderOnlyOnce = <T>({
  context,
  contextName,
}: UseProviderOnlyOnceParams<T>) => {
  const OuterProvider = useContext(context);
  const shouldReportMultipleUsage = useRef(true);

  useEffect(() => {
    if (OuterProvider && shouldReportMultipleUsage.current) {
      if (isInExoSkeleton()) {
        report({
          type: REPORT_TYPES.info,
          value: `[Context Info] - ${contextName} is already in use more than once in react tree`,
          context: {
            contextName,
          },
        });
      }
      console.warn(
        `${contextName} is already in use, please use only one instance of ${contextName} (you may be wrapped with alloy provider)`,
      );
      shouldReportMultipleUsage.current = false;
    }
  }, [OuterProvider, context.displayName, contextName]);

  return null;
};
